import { getFileTypeFromBase64 } from './filteTypeFromBase64';

const convertBase64Toblob = (
  base64: string,
  fileName: string
): { blob: Blob; fileName: string } => {
  // MIME type based on signature
  const mimeType = getFileTypeFromBase64(base64);

  // Get file extension from MIME type
  const fileExtension = mimeType.split('/')[1];
  const fileNameWithExt = `${fileName}.${fileExtension}`;

  // Decode the base64 string
  const binaryString = window.atob(base64);
  const binaryLength = binaryString.length;
  const binaryArray = new Uint8Array(binaryLength);

  for (let i = 0; i < binaryLength; i++) {
    binaryArray[i] = binaryString.charCodeAt(i);
  }

  // Create a Blob from the binary data
  const blob = new Blob([binaryArray], { type: mimeType });
  return {
    blob,
    fileName: fileNameWithExt
  };
};

export default convertBase64Toblob;
